module.exports = {
  "country": "FI",
  "artist": "Lordi",
  "song": "Hard Rock Hallelujah",
  "year": "2006",
  "place": "1",
  "spotify": "7BxBHNoIqiybZHlbeqMmvP"
};